module.exports = __webpack_public_path__ + "static/media/meeting.b6d949c1.svg";